import Dashboard from '../containers/dashboard'
import PaymentsRejectedManagement from '../containers/payments-rejected-management'

const PaymentsRejected = () => {
  return (
    <Dashboard>
      <PaymentsRejectedManagement />
    </Dashboard>
  )
}

export default PaymentsRejected
